import windowFk from "./windowFk";
import messageTransport from "../messageTransport";
// create postMessage ability
var createDispatcher = function createDispatcher(transport) {
  return function (action, message) {
    transport.dispatch(action, message);
  };
};
var createSubscription = function createSubscription(transport, config) {
  return function (action, fn) {
    transport.subscribe(action, fn);
  };
};
var createUnSubscription = function createUnSubscription(transport) {
  return function (action) {
    transport.unsubscribe(action);
  };
};
var createClientApp = function createClientApp(transport) {
  var dispatcher = createDispatcher(transport);
  var subscription = createSubscription(transport);
  var unsubscription = createUnSubscription(transport);
  return function () {
    return {
      config: transport.config,
      localOrigin: transport.localOrigin,
      dispatch: function dispatch(action, message) {
        return dispatcher(action, message);
        ;
      },
      subscribe: function subscribe(action, fn, config) {
        return subscription(action, fn, config);
      },
      unsubscribe: function unsubscribe(action) {
        return unsubscription(action);
      }
    };
  };
};
var createAppWrapper = function createAppWrapper(frame, config) {
  var transport = messageTransport.fromWindow(frame, config);
  messageTransport.initPostMessage(config);
  var appCreator = createClientApp(transport);
  return appCreator;
};

/**
 * @param config appkey
 * @returns 
 */
export var createApp = function createApp(config) {
  // appkey check
  var currentWindow = windowFk.getWindow();
  return createAppWrapper(currentWindow.parent, config)();
};